import { render, staticRenderFns } from "./bankEmpty.vue?vue&type=template&id=55a1d345"
import script from "./bankEmpty.vue?vue&type=script&lang=js"
export * from "./bankEmpty.vue?vue&type=script&lang=js"
import style0 from "./bankEmpty.vue?vue&type=style&index=0&id=55a1d345&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports